<div class="card-body p-3">

                <!-- Medication Add Form -->
                <div class="card mb-4">
                    <div class="card-body">

                        <!-- Praticien + Affection -->
                            <div class="row g-2 mb-2">
                                <div class="col-md-6">
                                    <ng-select [items]="itemsPraticien" bindLabel="full_name" bindValue="id"
                                        [(ngModel)]="itemToSave.praticien_id"
                                        placeholder="Praticien"
                                        class="form-control-sm">
                                    </ng-select>
                                </div>
                                <div class="col-md-6">
                                    <ng-select [items]="itemsAffection" bindLabel="libelle" bindValue="id"
                                        [(ngModel)]="itemToSave.affection_id"
                                        placeholder="Affection"
                                        class="form-control-sm">
                                    </ng-select>
                                </div>
                            </div>

                        <!-- Compact optique measurements form -->
                            <div class="row g-2 mb-2">
                                <!-- OD -->
                                <div class="col-md-5">
                                    <div class="card border-primary p-2">
                                        <div class="fw-bold text-center text-primary mb-2" style="font-size:0.85rem">OD — Oeil Droit</div>
                                        <div class="row g-1">
                                            <div class="col-6">
                                                <label class="form-label mb-0" style="font-size:0.75rem">SPH</label>
                                                <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="itemToSave.oeil_droit_sph" name="od_sph" step="0.25" placeholder="0.00">
                                            </div>
                                            <div class="col-6">
                                                <label class="form-label mb-0" style="font-size:0.75rem">CYL</label>
                                                <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="itemToSave.oeil_droit_cyl" name="od_cyl" step="0.25" placeholder="0.00">
                                            </div>
                                            <div class="col-6">
                                                <label class="form-label mb-0" style="font-size:0.75rem">AXE (°)</label>
                                                <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="itemToSave.oeil_droit_axe" name="od_axe" min="0" max="180" placeholder="0">
                                            </div>
                                            <div class="col-6">
                                                <label class="form-label mb-0" style="font-size:0.75rem">ADD</label>
                                                <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="itemToSave.oeil_droit_add" name="od_add" step="0.25" placeholder="0.00">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- OG -->
                                <div class="col-md-5">
                                    <div class="card border-success p-2">
                                        <div class="fw-bold text-center text-success mb-2" style="font-size:0.85rem">OG — Oeil Gauche</div>
                                        <div class="row g-1">
                                            <div class="col-6">
                                                <label class="form-label mb-0" style="font-size:0.75rem">SPH</label>
                                                <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="itemToSave.oeil_gauche_sph" name="og_sph" step="0.25" placeholder="0.00">
                                            </div>
                                            <div class="col-6">
                                                <label class="form-label mb-0" style="font-size:0.75rem">CYL</label>
                                                <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="itemToSave.oeil_gauche_cyl" name="og_cyl" step="0.25" placeholder="0.00">
                                            </div>
                                            <div class="col-6">
                                                <label class="form-label mb-0" style="font-size:0.75rem">AXE (°)</label>
                                                <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="itemToSave.oeil_gauche_axe" name="og_axe" min="0" max="180" placeholder="0">
                                            </div>
                                            <div class="col-6">
                                                <label class="form-label mb-0" style="font-size:0.75rem">ADD</label>
                                                <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="itemToSave.oeil_gauche_add" name="og_add" step="0.25" placeholder="0.00">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Distance interpupillaire -->
                                <div class="col-md-2">
                                    <div class="card p-2 text-center h-100 justify-content-center d-flex flex-column">
                                        <div class="fw-bold mb-1" style="font-size:0.75rem">D.I. (mm)</div>
                                        <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="itemToSave.distance_interpupillaire" name="di" min="40" max="80" placeholder="60">
                                    </div>
                                </div>
                            </div>

                            <!-- Options / Filtres -->
                            <div class="d-flex flex-wrap gap-1 mb-3 align-items-center">
                                <small class="fw-bold text-muted me-1">Options :</small>
                                <label class="opt-toggle" [class.active]="itemToSave.filtre_anti_uv">
                                    <input type="checkbox" hidden [(ngModel)]="itemToSave.filtre_anti_uv" name="filtre_anti_uv"> Anti-UV
                                </label>
                                <label class="opt-toggle" [class.active]="itemToSave.filtre_photocromique">
                                    <input type="checkbox" hidden [(ngModel)]="itemToSave.filtre_photocromique" name="filtre_photocromique"> Photochromique
                                </label>
                                <label class="opt-toggle" [class.active]="itemToSave.filtre_transition">
                                    <input type="checkbox" hidden [(ngModel)]="itemToSave.filtre_transition" name="filtre_transition"> Transition
                                </label>
                                <label class="opt-toggle" [class.active]="itemToSave.filtre_antibuee">
                                    <input type="checkbox" hidden [(ngModel)]="itemToSave.filtre_antibuee" name="filtre_antibuee"> Anti-buee
                                </label>
                                <label class="opt-toggle" [class.active]="itemToSave.filtre_bleu">
                                    <input type="checkbox" hidden [(ngModel)]="itemToSave.filtre_bleu" name="filtre_bleu"> Filtre bleu
                                </label>
                                <label class="opt-toggle" [class.active]="itemToSave.traitement_antireflet">
                                    <input type="checkbox" hidden [(ngModel)]="itemToSave.traitement_antireflet" name="traitement_antireflet"> Anti-reflet
                                </label>
                                <label class="opt-toggle" [class.active]="itemToSave.traitement_teinte">
                                    <input type="checkbox" hidden [(ngModel)]="itemToSave.traitement_teinte" name="traitement_teinte"> Teinte
                                </label>
                                <label class="opt-toggle" [class.active]="itemToSave.type_double_foyer">
                                    <input type="checkbox" hidden [(ngModel)]="itemToSave.type_double_foyer" name="type_double_foyer"> Double foyer
                                </label>
                                <label class="opt-toggle" [class.active]="itemToSave.type_progressif">
                                    <input type="checkbox" hidden [(ngModel)]="itemToSave.type_progressif" name="type_progressif"> Progressif
                                </label>
                            </div>

                        <div class="row g-2 mt-2 align-items-end">
                            <div class="col-md-10">
                                <textarea rows="1" [(ngModel)]="itemToSave.renseignement_clinique" class="form-control form-control-sm"
                                    name="renseignement_clinique" placeholder="Renseignement clinique"></textarea>
                            </div>
                            <div class="col-md-2">
                                <button style="width:100%"
                                    (click)="confirmSaveItem(itemToSave)" class="btn btn-success btn-sm">
                                    <i class="fas fa-paper-plane me-1"></i>Soumettre
                                </button>
                            </div>
                        </div>



                    </div>
                </div>
</div>